<div class="locker" [class.locker--active]="active" [class.buffer]="buffer"></div>